import { render } from "./customerBookings.vue?vue&type=template&id=a0e9932c&ts=true"
import script from "./customerBookings.vue?vue&type=script&lang=ts"
export * from "./customerBookings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__